import React, { useState } from "react";
import { ModalSliderSectionHeader } from "./ModalSliderSectionHeader";
// @ts-ignore
import { WBMSelectionCard } from "wbm-selection-card";

type ListProps = {
  header: string;
  link?: boolean;
  linkText?: string;
  clickAction?: any;
  list: any;
};

export const ModalOptionListHeader = ({ ...props }: ListProps) => {
  const [selected, setSelected] = useState(null);

  const clickSelected = (index: any) => {
    if (selected === index) {
      setSelected(null);
    } else {
      setSelected(index);
    }
  };

  return (
    <div className="modal-slider">
      {props.header ? (
        <ModalSliderSectionHeader link linkText="link" header="filter" />
      ) : null}
      {props.list
        ? props.list.map((option: any, i: number) => {
            return (
              <WBMSelectionCard
                key={"option-selection" + i}
                selected={selected == i ? true : false}
                onClick={() => clickSelected(i)}
                className="item-card"
              >
                <span>{option.text}</span>
              </WBMSelectionCard>
            );
          })
        : null}
    </div>
  );
};
